import { render, staticRenderFns } from "./price-unit.vue?vue&type=template&id=c057bd6a&scoped=true&"
import script from "./price-unit.vue?vue&type=script&lang=js&"
export * from "./price-unit.vue?vue&type=script&lang=js&"
import style0 from "./price-unit.vue?vue&type=style&index=0&id=c057bd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c057bd6a",
  null
  
)

export default component.exports